import { RankingListFilter } from './components/ranking-list-filter';
import { RankingListTable } from './components/ranking-list-table';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Pagination } from '~/components/Pagination/Pagination';
import { Discipline } from '~/pages/discipline/types';
import { useFilterForm } from '~/hooks/useFilterForm';
import { useRankingListQuery } from '../queries';
import { querySchema } from './query-schema';
import { Fragment } from 'react/jsx-runtime';
import { toIsMaleFilter } from '~/utils/sex';

export function Page() {
  const { values } = useFilterForm(querySchema.parse);

  const { data, isLoading } = useRankingListQuery({
    age_categories: values.age_category_id ? [values.age_category_id] : undefined,
    weight_classes: values.weight_class_id ? [values.weight_class_id] : undefined,
    discipline: values.discipline as Discipline | undefined,
    competition_type: values.competition_type_id,
    is_male: toIsMaleFilter(values.sex),
    start_date: values.from_date,
    page_size: values.pageSize,
    end_date: values.to_date,
    page: values.pageIndex,
  });

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Ranking" />
      </PageLayout.Header>

      <PageLayout.Section>
        <RankingListFilter />
        <RankingListTable results={data?.results ?? []} isLoading={isLoading} />
        <Pagination count={data?.count} />
      </PageLayout.Section>
    </Fragment>
  );
}
